import InfoDelivery from "./InfoDelivery"
export default InfoDelivery